import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const AttachVideoIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 16 16"
    >
      <path
        d="M7.99996 0.666626C3.95329 0.666626 0.666626 3.95329 0.666626 7.99996C0.666626 12.0466 3.95329 15.3333 7.99996 15.3333C12.0466 15.3333 15.3333 12.0466 15.3333 7.99996C15.3333 3.95329 12.0466 0.666626 7.99996 0.666626ZM7.99996 14C4.69329 14 1.99996 11.3066 1.99996 7.99996C1.99996 4.69329 4.69329 1.99996 7.99996 1.99996C11.3066 1.99996 14 4.69329 14 7.99996C14 11.3066 11.3066 14 7.99996 14Z"
        fill={color}
      />
      <path
        d="M11.3334 7.41998L6.66673 4.75331C6.24673 4.49331 5.65339 4.83331 5.66673 5.33331V10.6666C5.65339 11.16 6.24006 11.5066 6.66673 11.2466L11.3334 8.57998C11.7734 8.34664 11.7734 7.65331 11.3334 7.41998ZM7.00006 9.51998V6.48664L9.65339 8.00664L7.00006 9.52664V9.51998Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

AttachVideoIcon.displayName = 'AttachVideoIcon';
